import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PageContainer from "@src/components/containers/PageContainer";
import PageContent from "@src/components/containers/PageContent/PageContent";
import BasePortalPageHeader from "@src/components/common/BasePortalPageHeader";
import PageFooter from "@src/components/common/PageFooter";
import useDjangoMessages from "@src/hooks/useDjangoMessages";

export default function BasePortalContainer(): React.JSX.Element {
  const location = useLocation();
  useDjangoMessages();

  useEffect(() => {
    if (window.pendo && !!window.pendo.pageLoad) {
      window.pendo.pageLoad();
      console.log("[Pendo] pageLoad triggered for path:", location.pathname);
    }
  }, [location.pathname]);

  return (
    <PageContainer>
      <BasePortalPageHeader />
      <PageContent>
        <Outlet />
      </PageContent>
      <PageFooter />
    </PageContainer>
  );
}
